import { render, staticRenderFns } from "./ActivityDetails.vue?vue&type=template&id=320d099a&scoped=true"
import script from "./ActivityDetails.vue?vue&type=script&lang=js"
export * from "./ActivityDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "320d099a",
  null
  
)

export default component.exports